export const PRELOADS = {
    NONE: 'none',
    METADATA: 'metadata',
    AUTO: 'auto'
};
